import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { mapFormOptions } from "../shared";

export const VectorMapURLBlock = withForm({
  ...mapFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>Vector Map Source</FieldLegend>
        <FieldDescription>
          Vector tile URL for your map style. Supports cloud services like
          MapTiler or a local MapTiler Server for offline use.
        </FieldDescription>

        <FieldGroup>
          <Field>
            <form.AppField name="darkMapUrl">
              {(field) => <field.TextField label="Dark map URL" />}
            </form.AppField>
          </Field>

          <Field>
            <form.AppField name="lightMapUrl">
              {(field) => <field.TextField label="Light map URL" />}
            </form.AppField>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
